// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__25w-P","circle":"styles_circle__3Hq9s","textWrapper":"styles_textWrapper__21k6z","text":"styles_text__3lQXq","body":"styles_body__2M-2c"};